var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-led-canvas",on:{"click":function($event){return _vm.$emit('click')}}},[_c('canvas',{ref:"canvas",attrs:{"width":_vm.width,"height":_vm.height}})])}
var staticRenderFns = []

export { render, staticRenderFns }